/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'automation-menu.empty-state.image.alt': '空白的自動化列表圖示',
  'automation-menu.empty-state.learn-more.link': '進一步了解手動觸發程序',
  'automation-menu.modal.empty.automations.admin.description':
    '使用手動觸發程序填入選項選單，讓任何人或您指定的人員都可以套用為一鍵式自動化功能。',
  'automation-menu.modal.empty.automations.user.description': '管理員尚未設定任何手動觸發的自動化。',
  'automation-menu.modal.error.description': '載入時間過長。請嘗試重新整理頁面。',
  'automation-menu.modal.error.image.alt': '錯誤圖示',
  'automation-menu.modal.footer.automate-button': '自動化',
  'automation-menu.modal.footer.cancel-button': '取消',
  'automation-menu.modal.footer.get-started-button': '建立自動化',
  'automation-menu.modal.footer.ok-button': '確定',
  'automation-menu.modal.header.icon.label': '自動化強制回應標頭圖示',
  'automation-menu.success-state.message': '您的自動化正在進行中',
  'fabric.linking.access_exists_description': '要求存取權以檢視 {hostname} 的這項內容。',
  'fabric.linking.actions': '動作',
  'fabric.linking.add_account': '新增帳戶',
  'fabric.linking.ai_summarize': '總結',
  'fabric.linking.ai_summarized': '由 Atlassian Intelligence 總結',
  'fabric.linking.ai_summarized_abbreviation': '由 AI 總結',
  'fabric.linking.ai_summarized_info': '資訊品質可能會有變化。<a>深入了解</a>',
  'fabric.linking.ai_summarized_info_short': '內容品質可能會有所不同',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence 運作中...',
  'fabric.linking.ai_summary_action': '使用 AI 產生摘要',
  'fabric.linking.ai_summary_action_description': '使用 Atlassian Intelligence 摘要此連結的內容。',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    '我們無法顯示此摘要的結果，因為違反 <a>Atlassian 的可接受使用政策</a>。',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence 目前無法為您產生摘要，因為需要摘要的內容太多。',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) 沒有回應。請稍後再試一次，或<a>檢查 AI 的狀態</a>。',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence 無法處理您的要求，因為您的內容包含 HIPAA 受限內容的連結。',
  'fabric.linking.assigned_to': '已指派給 {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    '將自動化套用至 <b>{name}</b>。{br}可用的選項是由 Confluence 和空間管理員所控管。',
  'fabric.linking.automation-action.confluence.page.modal.title': '頁面自動化',
  'fabric.linking.automation-action.icon.label': '自動化圖示',
  'fabric.linking.automation-action.title': '檢視自動化規則',
  'fabric.linking.automation-action.tooltip': '選取要執行的自動化規則',
  'fabric.linking.beta': '測試版',
  'fabric.linking.cancel': '取消',
  'fabric.linking.cannot_connect': '無法連結，請再試一次',
  'fabric.linking.cannot_find_link': '找不到連結',
  'fabric.linking.check_this_link': '檢查此連結',
  'fabric.linking.click_to_join': '加入 {context}',
  'fabric.linking.click_to_join_description': '您已獲得核准，因此可以立即加入 {context}。',
  'fabric.linking.close': '關閉',
  'fabric.linking.connect_account_description': '我們會開啟新的頁面來協助您連結 {name} 帳戶',
  'fabric.linking.connect_link_account': '連線以預覽',
  'fabric.linking.connect_link_account_card_view': '連結',
  'fabric.linking.connect_link_account_card_view_description': '若要顯示此連結的預覽，請連接您的 {context} 帳戶。',
  'fabric.linking.connect_link_account_card_view_name': '連結 {context} 帳戶',
  'fabric.linking.connect_to': '連結至 {name}',
  'fabric.linking.connect_unauthorised_account_action': '連結至 {context}',
  'fabric.linking.connect_unauthorised_account_description':
    '連接您的 {context} 帳戶，以在各個 Atlassian 產品上的工作協同合作。',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    '連接您的帳戶，以在各個 Atlassian 產品上的工作協同合作。',
  'fabric.linking.continue': '繼續',
  'fabric.linking.copied_summary_action_description': '已將摘要複製到剪貼簿',
  'fabric.linking.copied_url_to_clipboard': '已複製！',
  'fabric.linking.copy_summary_action': '複製摘要',
  'fabric.linking.copy_summary_action_description': '複製摘要',
  'fabric.linking.copy_url_to_clipboard': '複製連結',
  'fabric.linking.couldnt_load_link': '基於不明原因，我們無法載入此連結。',
  'fabric.linking.create_on_absolute': '於 {context} 建立',
  'fabric.linking.create_on_relative': '建立時間：{context}',
  'fabric.linking.created_by': '建立者：{context}',
  'fabric.linking.delete': '刪除',
  'fabric.linking.direct_access': '立即加入',
  'fabric.linking.direct_access_description': '您的團隊使用 {product} 協作，您可以立即開始使用！',
  'fabric.linking.direct_access_title': '加入 {product} 以檢視此內容',
  'fabric.linking.download': '下載',
  'fabric.linking.download_description': '將此檔案下載到您的本機儲存空間',
  'fabric.linking.download_file': '下載檔案',
  'fabric.linking.edit': '編輯',
  'fabric.linking.follow': '追蹤',
  'fabric.linking.follow_goal': '追蹤目標',
  'fabric.linking.follow_goal_description': '追蹤此目標以取得更新通知',
  'fabric.linking.follow_goal_error': '我們在嘗試追蹤目標時遇到錯誤。請檢查您的連線或重新整理頁面，然後再試一次。',
  'fabric.linking.follow_project': '追蹤專案',
  'fabric.linking.follow_project-galaxia': '追蹤空間',
  'fabric.linking.follow_project_description': '追蹤以取得此專案的通知',
  'fabric.linking.follow_project_description-galaxia': '追蹤以取得此空間的通知',
  'fabric.linking.follow_project_error': '我們在嘗試追蹤專案時遇到錯誤。請檢查您的連線或重新整理頁面，然後再試一次。',
  'fabric.linking.follow_project_error-galaxia':
    '我們在嘗試追蹤空間時遇到錯誤。請檢查您的連線或重新整理頁面，然後再試一次。',
  'fabric.linking.forbidden_access': '您的存取遭拒',
  'fabric.linking.forbidden_description': '請連絡您的管理員以要求 {hostname} 存取權。',
  'fabric.linking.forbidden_title': '您無法存取此內容',
  'fabric.linking.generic_error_message': '發生錯誤',
  'fabric.linking.go_back': '返回',
  'fabric.linking.invalid_permissions': '受限制的內容',
  'fabric.linking.invalid_permissions_description': '您需要請求存取或嘗試不同的帳戶，來檢視此預覽。',
  'fabric.linking.join_to_view': '加入 {context} 以查看此議題',
  'fabric.linking.join_to_view-issue-term-refresh': '加入 {context} 以查看此工作項目',
  'fabric.linking.learn_more_about_connecting_account': '進一步了解如何將您的帳戶連接至 Atlassian 產品。',
  'fabric.linking.learn_more_about_smart_links': '深入了解智慧連結。',
  'fabric.linking.link_safety_warning_message': '此連結 {unsafeLinkText} 會帶您前往不同的網站，<a>actual link here</a>',
  'fabric.linking.loading': '正在載入...',
  'fabric.linking.modified_on_absolute': '更新於 {context}',
  'fabric.linking.modified_on_relative': '更新時間：{context}',
  'fabric.linking.more_actions': '更多動作',
  'fabric.linking.no_access_title': '加入 {product} 以檢視此內容',
  'fabric.linking.not_found_description': '該頁面不存在，或在新增此連結後可能已變更。',
  'fabric.linking.not_found_title': '我們無法向您顯示此 {product} 頁面',
  'fabric.linking.open_issue_in_jira': 'Jira 中的待處理議題',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Jira 中的待處理工作項目',
  'fabric.linking.open_link_in_a_new_tab': '在新分頁中開啟連結',
  'fabric.linking.owned_by': '負責人：{context}',
  'fabric.linking.owned_by_override': '作者：{context}',
  'fabric.linking.pending_request': '您的存取要求擱置中',
  'fabric.linking.preview_close': '關閉預覽',
  'fabric.linking.preview_description': '開啟此連結的全螢幕預覽',
  'fabric.linking.preview_improved': '開啟預覽',
  'fabric.linking.preview_max_size': '全螢幕檢視',
  'fabric.linking.preview_min_size': '關閉全螢幕',
  'fabric.linking.preview_modal': '開啟預覽強制回應',
  'fabric.linking.preview_panel': '開啟預覽面板',
  'fabric.linking.priority_blocker': '受阻',
  'fabric.linking.priority_critical': '嚴重',
  'fabric.linking.priority_high': '高',
  'fabric.linking.priority_highest': '最高',
  'fabric.linking.priority_low': '低',
  'fabric.linking.priority_lowest': '最低',
  'fabric.linking.priority_major': '主要',
  'fabric.linking.priority_medium': '中',
  'fabric.linking.priority_minor': '次要',
  'fabric.linking.priority_trivial': '不太重要',
  'fabric.linking.priority_undefined': '未定義',
  'fabric.linking.read_time': '{context} 分鐘閱讀時間',
  'fabric.linking.related': '相關',
  'fabric.linking.related_links_found_in': '找到的位置',
  'fabric.linking.related_links_includes_links_to': '將連結納入',
  'fabric.linking.related_links_modal_error_description': '請檢查連線或重新整理頁面，然後再試一次',
  'fabric.linking.related_links_modal_error_title': '我們在載入相關連結時遇到問題',
  'fabric.linking.related_links_modal_title': '相關連結',
  'fabric.linking.related_links_modal_unavailable_description':
    '我們會持續檢閱更新的頁面或其他內容類型，並新增相關的連結',
  'fabric.linking.related_links_modal_unavailable_title': '我們找不到任何相關連結',
  'fabric.linking.related_links_not_found': '我們沒有找到任何可在這裡顯示的連結。',
  'fabric.linking.related_links_view_related_links': '檢視相關連結',
  'fabric.linking.related_links_view_related_urls': '查看最近的連結',
  'fabric.linking.request_access': '要求存取權',
  'fabric.linking.request_access_description': '您的團隊使用 {product} 來協作。向您的管理員傳送存取要求。',
  'fabric.linking.request_access_pending': '待核准',
  'fabric.linking.request_access_pending_description': '您的 {hostname} 存取要求正在等待管理員核准。',
  'fabric.linking.request_access_pending_title': '{product} 的存取權待核准',
  'fabric.linking.request_access_to_view': '要求存取 {context} 以檢視此議題',
  'fabric.linking.request_access_to_view-issue-term-refresh': '要求存取 {context} 以檢視此工作項目',
  'fabric.linking.request_denied': '您的存取要求遭拒',
  'fabric.linking.request_denied_description':
    '您的管理員並未核准您的要求，因此您無法檢視 {hostname} 的 {product} 頁面。',
  'fabric.linking.restricted_link': '連結受到限制，請嘗試其他帳戶',
  'fabric.linking.retry': '重試',
  'fabric.linking.save': '儲存',
  'fabric.linking.sent_on_absolute': '傳送日期：{context}',
  'fabric.linking.sent_on_relative': '傳送時間：{context}',
  'fabric.linking.srclink': '使用以下檢視：',
  'fabric.linking.srclinkunknown': '檢視原始狀態',
  'fabric.linking.status_change_load_error': '我們無法載入狀態和轉換',
  'fabric.linking.status_change_permission_error': '您沒有轉換此議題的權限。',
  'fabric.linking.status_change_permission_error-issue-term-refresh': '您沒有轉換此工作項目的權限。',
  'fabric.linking.status_change_update_error': '我們無法更新狀態',
  'fabric.linking.team_members_count': '{context} 位成員',
  'fabric.linking.try_again': '再試一次',
  'fabric.linking.try_another_account': '使用其他帳戶嘗試',
  'fabric.linking.unassigned': '未指派',
  'fabric.linking.unauthorised_account_description':
    '您正在嘗試預覽私人 {context} 頁面的連結。建議您檢閱 URL 或連絡頁面擁有者。',
  'fabric.linking.unauthorised_account_description_no_provider':
    '您正在嘗試預覽私人頁面的連結。建議您檢閱 URL 或連絡頁面擁有者。',
  'fabric.linking.unauthorised_account_name': '無法顯示 {context} 的私人頁面',
  'fabric.linking.unauthorised_account_name_no_provider': '無法顯示私人頁面',
  'fabric.linking.unfollow': '取消追蹤',
  'fabric.linking.unfollow_goal': '取消追蹤目標',
  'fabric.linking.unfollow_goal_description': '取消追蹤，以停止接收此目標的通知',
  'fabric.linking.unfollow_goal_error':
    '我們在嘗試取消追蹤目標時遇到錯誤。請檢查您的連線或重新整理頁面，然後再試一次。',
  'fabric.linking.unfollow_project': '取消追蹤專案',
  'fabric.linking.unfollow_project-galaxia': '取消追蹤空間',
  'fabric.linking.unfollow_project_description': '取消追蹤，以停止接收專案通知',
  'fabric.linking.unfollow_project_description-galaxia': '取消追蹤，以停止接收空間通知',
  'fabric.linking.unfollow_project_error':
    '我們在嘗試取消追蹤專案時遇到錯誤。請檢查您的連線或重新整理頁面，然後再試一次。',
  'fabric.linking.unfollow_project_error-galaxia':
    '我們在嘗試取消追蹤空間時遇到錯誤。請檢查您的連線或重新整理頁面，然後再試一次。',
  'fabric.linking.unlink_account': '取消帳戶的連結',
  'fabric.linking.updated_by': '修改者：{context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': '檢視',
};
